/**
 * Regions Service
 * Handles region-related API calls.
 */

import api from '../utils/api';

/**
 * Get all regions
 * GET /v1/regions/
 */
export const getRegions = async () => {
  try {
    const response = await api.get('/v1/regions/');
    const list = Array.isArray(response) ? response : response?.data ?? [];
    if (Array.isArray(list)) {
      return { success: true, data: list, message: 'Regions retrieved successfully' };
    }
    if (response?.status === 'success' && response?.data) {
      return { success: true, data: response.data, message: response.message || 'Regions retrieved successfully' };
    }
    return { success: false, error: response?.message || 'Failed to retrieve regions', data: null };
  } catch (error) {
    console.error('Get regions error:', error);
    const errorMessage = error?.response?.message || error?.response?.error || error?.message || 'Failed to retrieve regions. Please try again.';
    return { success: false, error: errorMessage, data: null };
  }
};

/**
 * Create a region
 * POST /v1/regions/
 */
export const createRegion = async (payload) => {
  try {
    const response = await api.post('/v1/regions/', {
      name: payload.name?.trim(),
      code: payload.code?.trim() || undefined,
    });
    const data = response?.data ?? response;
    if (response?.status === 'success' && data) {
      return { success: true, data, message: response.message || 'Region created successfully' };
    }
    if (data?.id) {
      return { success: true, data, message: 'Region created successfully' };
    }
    return { success: false, error: response?.message || 'Failed to create region', data: null };
  } catch (error) {
    console.error('Create region error:', error);
    const errorMessage = error?.response?.message || error?.response?.error || error?.message || 'Failed to create region. Please try again.';
    return { success: false, error: errorMessage, data: null };
  }
};

/**
 * Delete a region
 * DELETE /v1/regions/{region_id}
 * 400: Region is assigned to one or more centers — reassign those centers before deleting.
 */
export const deleteRegion = async (regionId) => {
  try {
    const response = await api.delete(`/v1/regions/${regionId}`);
    if (response?.status === 'success' || response?.message) {
      return { success: true, message: response.message || 'Region deleted successfully' };
    }
    return { success: false, error: response?.message || response?.error || 'Failed to delete region' };
  } catch (error) {
    console.error('Delete region error:', error);
    const errorMessage = error?.response?.message || error?.response?.error || error?.message || 'Failed to delete region. It may be in use by centers.';
    return { success: false, error: errorMessage };
  }
};

const regionsService = { getRegions, createRegion, deleteRegion };
export default regionsService;
